import { render } from "./ModernizedDailySummaryList.vue?vue&type=template&id=3780e6b0&scoped=true"
import script from "./ModernizedDailySummaryList.vue?vue&type=script&lang=js"
export * from "./ModernizedDailySummaryList.vue?vue&type=script&lang=js"

import "./ModernizedDailySummaryList.vue?vue&type=style&index=0&id=3780e6b0&scoped=true&lang=css"

import exportComponent from "/root/dirif/prod/dirif-fo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3780e6b0"]])

export default __exports__